// extracted by mini-css-extract-plugin
export default {"Team":"Team_Team__g33-q","cardContainer":"Team_cardContainer__aoRP4"};